
function preventClick() {
	document.addEventListener("contextmenu", event => {
		event.preventDefault();
	});
}

export default preventClick;